import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function makeAdminClient(token) {
  const cx = axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });
  return cx;
}
